var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c7a870a9e9430dbec4c9e8657bdc9f62.js').default;export default
        Object.assign({}, scope_0 )
    